import React from 'react';
import logo from '../logo.png';
import styles from '../styles';
import useMediaQuery from '../hooks/useMediaQuery';
import { useLanguage } from '../contexts/LanguageContext';
import WhatsAppButton from './WhatsAppButton';

const Header = () => {
    const isMobile = useMediaQuery('(max-width: 480px)');
    const { language, setLanguage, t } = useLanguage();

    const headerStyles = {
        container: {
            width: '100%',
            padding: isMobile ? '1rem' : '1rem 2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#FFFFFF',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 1000,
        },
        logoContainer: {
            display: 'flex',
            alignItems: 'center',
            minWidth: 0, // Ensure the container can shrink
        },
        logo: {
            height: '2.5rem',
            marginRight: '0.75rem',
        },
        appName: {
            fontSize: isMobile ? '1.25rem' : '1.75rem',
            fontWeight: 'bold',
            color: styles.brandColor,
            margin: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        rightContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: isMobile ? '0.5rem' : '1rem',
        },
        select: {
            padding: isMobile ? '0.3rem' : '0.5rem',
            borderRadius: '5px',
            border: `1px solid ${styles.brandColor}`,
            backgroundColor: '#fff',
            cursor: 'pointer',
            fontSize: isMobile ? '0.8rem' : '1rem',
            color: '#333',
        },
        navButton: {
            padding: isMobile ? '0.5rem 1rem' : '0.5rem 1.5rem',
            backgroundColor: styles.brandColor,
            color: 'white',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
            fontWeight: 'bold',
            textDecoration: 'none',
            flexShrink: 0, // Prevent the button from shrinking
            fontSize: isMobile ? '0.9rem' : '1rem',
        }
    };

    // A simple function to handle the download link
    const handleDownloadClick = () => {
        window.open('https://play.google.com/store/apps/details?id=com.retterplus.android', '_blank');
    };

    return (
        <header style={headerStyles.container}>
            <div style={headerStyles.logoContainer}>
                <img src={logo} alt="RetterPlus Logo" style={headerStyles.logo} />
                <h1 style={headerStyles.appName}>{t('header.appName')}</h1>
            </div>
            <div style={headerStyles.rightContainer}>
                <select
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                    style={headerStyles.select}
                    aria-label={t('header.selectLanguage')}
                >
                    <option value="de">Deutsch</option>
                    <option value="en">English</option>
                </select>
                <WhatsAppButton style={{ marginLeft: 0 }} />
                {!isMobile && (
                    <a href="#download" onClick={handleDownloadClick} style={headerStyles.navButton}>
                        {t('header.download')}
                    </a>
                )}
            </div>
        </header>
    );
};

export default Header;
